import { showToast } from "./toast.utils";
import { TOAST } from "constants/common";

const wrapToast = (type) => (title, text, options) => {
    if (typeof title === 'object' && title !== null && !title.$$typeof) {
        return showToast({ ...title, type });
    }
    return showToast({ type, title, text, options });
};

export const toastService = {
    success: wrapToast(TOAST.TYPE.SUCCESS),
    error: wrapToast(TOAST.TYPE.ERROR),
    warning: wrapToast(TOAST.TYPE.WARNING),
    info: wrapToast(TOAST.TYPE.INFO),
    show: (params) => showToast(params),
    apiToast: ({
        res,
        code,
        values,
        options,
        successCodes = [0]
    }) => {
        if (!res || !code) return
        const responseCode = res?.code
        const titleKey = code?.[responseCode]
        if (!titleKey) return

        const isSuccess = successCodes.includes(responseCode)
        if (isSuccess) toastService.success({ titleKey, values, options })
        else toastService.error({ titleKey, values, options })
    }

};

export default toastService;
